<template>
    <p class="adv-subtitle"><slot></slot></p>
</template>
<script>
export default {
    name: 'AdvSubTitle'
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.adv-subtitle {
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    color: #515666;
    @include media-600 {
        font-size: 16px;
        line-height: 20px;
        font-family: var(--font-medium);
    }
}
</style>
